(function () {
  function normalizeSearchTerm(value) {
    return String(value || "")
      .normalize("NFKC")
      .trim()
      .toLocaleLowerCase()
      .replace(/[‐‑‒–—―]/g, "-")
      .replace(/\s+/g, " ");
  }

  function buildDestinationLookup(destinations) {
    var lookup = new Map();

    destinations.forEach(function (destination) {
      [destination.destination].concat(destination.aliases || []).forEach(function (term) {
        lookup.set(normalizeSearchTerm(term), destination.destination);
      });

      (destination.cities || []).forEach(function (city) {
        [city.name].concat(city.aliases || []).forEach(function (term) {
          lookup.set(normalizeSearchTerm(term), destination.destination);
        });
      });
    });

    return lookup;
  }

  function initializeDestinationSearch() {
    var destinations = window.destinationSearchData;
    var form = document.querySelector(".custom-search-bar form.search-container");

    if (!Array.isArray(destinations) || !form || form.dataset.destinationSearchReady === "true") {
      return;
    }

    var input = form.querySelector('input[name="q"]');

    if (!input) {
      return;
    }

    var lookup = buildDestinationLookup(destinations);
    form.dataset.destinationSearchReady = "true";

    form.addEventListener("submit", function () {
      var destination = lookup.get(normalizeSearchTerm(input.value));

      if (destination) {
        input.value = destination;
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeDestinationSearch);
  } else {
    initializeDestinationSearch();
  }
})();
